import React, { FC } from 'react';

import { sanitize } from 'dompurify';

import RawHTML from '../RawHTML/RawHTML';

interface SanitizeHTMLProps {
  children?: string;
}

const SanitizeHTML: FC<SanitizeHTMLProps> = props => {
  const { children: html = '' } = props;

  return <RawHTML>{sanitize(html, { ADD_ATTR: ['target'] })}</RawHTML>;
};

export default SanitizeHTML;
